import "./App.scss";
import Header from "./components/Header";
import NavBar from "./components/NavBar";
import ExperienceSection from "./components/ExperienceSection";
import SkillSection from "./components/SkillSection";
import ProjectSection from "./components/ProjectSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <NavBar />
      <main>
        <ExperienceSection />
        <SkillSection />
        <ProjectSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
